module.exports = __webpack_public_path__ + "static/media/pave_logo_white_rvb.c09bb027.png";